import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTheirishtimesComponent } from './simple-icons-theirishtimes.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTheirishtimesComponent ],
    exports:      [ SimpleIconsTheirishtimesComponent ],
    bootstrap:    []
})
export class SimpleIconsTheirishtimesModule {}
